<template>
  <div class="card mb-2">
    <div class="card-body bg-secondary pt-2 pb-0 pl-1 pr-2">
      <b-form class="search-form" @submit.prevent="onSearch">
        <div class="d-flex">
          <div class="row align-items-center">
            <div class="input-wrapper">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="sale_no"/>
            </div>
            <div class="input-wrapper">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="title"/>
            </div>
            <div class="input-wrapper">
              <b-form-group class="">
                <date-range-picker
                  class="d-flex w-100"
                  @update="onDateRangeApply"
                  showWeekNumbers
                  showDropdowns
                  ref="picker"
                  :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY HH:mm:ss' }"
                  v-model="dateRange">
                  <template v-slot:input="picker" style="min-width: 350px;">
                    <span v-if="!picker.startDate" class="text-muted">
                      {{ $t('Date Range') }}
                    </span>
                    <span style="font-size: 10px" v-else>
                      {{ picker.startDate | toDate }} - {{ picker.endDate | toDate }}
                    </span>
                  </template>
                </date-range-picker>
              </b-form-group>
            </div>
            <div class="input-wrapper">
              <input-widget :model="searchModel" attribute="currency_uuid" type="select2" value-field="uuid"
                            :label="false" :options="{placeholder: $t('Currency')}"
                            display-field="${item.code} (${item.symbol})" :items="currencies"/>
            </div>
            <div class="input-wrapper">
              <input-widget :model="searchModel" attribute="type" type="select2" :items="auctionTypes" value-field="key"
                            :label="false" :options="{placeholder: $t('Type')}" display-field="${item.text}"/>
            </div>
            <div class="input-wrapper">
              <department-select-input-widget @select="onDepartmentSelect" :model="searchModel" :label="false"
                                              :options="{placeholder: $t('Department')}" attribute="department_uuid"/>
            </div>
            <div class="input-wrapper">
              <input-widget :model="searchModel" attribute="status" type="select2" :items="statuses" value-field="value"
                            :label="false" :options="{placeholder: $t('Status')}" display-field="${item.key}" multiple />
            </div>
            <div class="input-wrapper">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="live_reference"/>
            </div>
            <div class="input-wrapper">
              <input-widget :model="searchModel" attribute="is_published" type="checkbox"/>
            </div>
            <div class="input-wrapper">
              <input-widget :model="searchModel" attribute="is_listed" type="checkbox"/>
            </div>
            <div class="input-wrapper">
              <input-widget :model="searchModel" attribute="is_after_sale" type="checkbox"/>
            </div>
            <div class="input-wrapper">
              <input-widget :model="searchModel" attribute="is_private" type="checkbox"/>
            </div>
            <div class="input-wrapper">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="buyer_group_account"
                  v-if="vendorBuyerGroupAccountsEnabled"/>
            </div>
            <div class="input-wrapper">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="vendor_group_account"
                  v-if="vendorBuyerGroupAccountsEnabled"/>
            </div>
          </div>
          <div class="search-btn-wrapper">
            <b-button variant="primary" @click.prevent="onResetClick">
              <font-awesome-icon icon="undo" class="icon"/>
              {{ $t('Reset') }}
            </b-button>
            <b-button type="submit" variant="primary" class="ml-2">
              <font-awesome-icon icon="search" class="icon"/>
              {{ $t('Search') }}
            </b-button>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
  import InputWidget from "../../core/components/input-widget/InputWidget";
  import DepartmentSelectInputWidget from "../../core/widgets/DepartmentSelectInputWidget";
  import {createNamespacedHelpers} from "vuex";
  import DateRangePicker from 'vue2-daterange-picker'
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

  const {mapState, mapActions} = createNamespacedHelpers('sales');
  const {mapState: mapStateGlobal} = createNamespacedHelpers('global');

  export default {
    name: "SaleSearch",
    components: {DepartmentSelectInputWidget, InputWidget, DateRangePicker},
    data() {
      return {
        filteredData: [],
        dateRange: {startDate: null, endDate: null}
      }
    },
    computed: {
      ...mapStateGlobal(['currencies', 'vendorBuyerGroupAccountsEnabled']),
      ...mapState({
        searchModel: state => state.tableData[state.tableSource].searchModel,
        auctionTypes: state => state.auctionTypes,
        statuses: state => state.statuses,
      }),
    },
    methods: {
      ...mapActions(['getTableData', 'updateSearchModel', 'resetTable', 'resetTableDataPaginationPage']),
      async onDepartmentSelect(department) {
        this.updateSearchModel({department});
      },
      async onSearch() {
        await this.updateSearchModel(this.searchModel);
        this.resetTableDataPaginationPage();
        this.getTableData();
      },
      onResetClick() {
        this.dateRange = {startDate: null, endDate: null};
        this.resetTable();
      },
      onDateRangeApply() {
        this.searchModel.dateRange = this.dateRange
      }
    },
    mounted() {
      if (this.searchModel && this.searchModel.dateRange) {
        this.dateRange = this.searchModel.dateRange;
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
